import logo from './logo-inovacao.png'
import axios from "axios";

import {useState} from 'react'
import { Link, useNavigate } from 'react-router-dom';

function Register() {

    const navigate = useNavigate()

    const [nome, setNome] = useState()
    const [empresa, setEmpresa] = useState()
    const [email, setEmail] = useState()
    const [password, setPassword] = useState()

    const  doRegister = async (e) => {
        e.preventDefault()
        if (!nome || !empresa || !email || !password) {
            alert("Faltam dados para o registro!")
            return
        }
        try {
            const res = await axios.post(`Account/InsertCompany`, {TOKEN: "@@@@@", Company: empresa, Name: nome, eMail: email, Password: password})
            if (res.data.Return == false) {
                if (res.data.Code == 100) {
                    alert("E-mail já cadastrado!")
                    return
                    //code 103 empresa já existe
                } else {
                    alert("erro na inclusao da empresa")
                }
            } else {
                if (res.data.Code) {
                    alert(res.data.Code)
                    navigate('/login')
                } 
            }
        }
        catch(err){
            alert(err)
        }

    }


  return (
 <div className="container vh-100 d-flex justify-content-center align-items-center">
        <div className="row w-100 d-flex justify-content-center align-items-center p-2">
            <div className="col-12 col-md-4 d-flex flex-column align-items-center bg-white p-5 shadow-sm">
                <img src={logo} alt="logo" style={{height:120, width:120,}} />

                <h2>Registre-se no SUITI</h2>

                <form onSubmit={(e)=> doRegister(e)} class="w-100 mt-3" role="form" >
                    <div class="form-group mb-3">
                        <input type="text" class="form-control" placeholder="Empresa" required=""  onChange={(e)=> setEmpresa(e.target.value)}/>
                    </div>
                    <div class="form-group mb-3">
                        <input type="text" class="form-control" placeholder="Nome" required=""  onChange={(e)=> setNome(e.target.value)}/>
                    </div>
                    <div class="form-group mb-3">
                        <input type="email" class="form-control" placeholder="Email" required=""  onChange={(e)=> setEmail(e.target.value)}/>
                    </div>
                    <div class="form-group mb-3">
                        <input type="password" class="form-control" placeholder="Senha" required=""  onChange={(e)=> setPassword(e.target.value)}/>
                    </div>
                    <div class="form-group mb-3">
                            <div class="checkbox i-checks"><label> <input type="checkbox" /><i></i> Concordo com os termos e políticas </label></div>
                    </div>
                    <button type="submit" class="btn btn-success w-100">REGISTRAR</button>

                    <p class="text-muted text-center small mb-0 mt-5">Já tem uma conta?</p>
                    <Link to="/login"><a class="btn btn-outline-secondary w-100">LOGIN</a></Link>
                </form>
            </div>
            
        </div>
    </div>
  );
}

export default Register;